export default {
  homePhone: 'homePhone',
  businessWebAddress: 'businessWebAddress',
};
